<div class="ecat-mobile-search">
    <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="onTabChange($event)"
        [hidden]="showDetail">
        <nz-tab nzTitle="首页">
        </nz-tab>
        <nz-tab nzTitle="搜索车型">
            <div *ngIf="carModalVisible">
                <search-by-car (dataEvent)="receiveData($event)" *ngIf="isVinSearchVisible"></search-by-car>
            </div>
        </nz-tab>
        <!-- <nz-tab nzTitle="搜索VIN码">
            <div *ngIf="vinVisible">
                <app-product-search></app-product-search>
                <app-vin-parts-search [activeTabIndex]="selectedTabIndex" *ngIf="isProductVinPartsSearchVisible"
                    (viewDetail)="onViewDetail($event)"></app-vin-parts-search>
            </div>
        </nz-tab> -->
        <nz-tab nzTitle="搜索产品">
            <div *ngIf="productVisible">
                <search-by-material></search-by-material>
            </div>
        </nz-tab>
    </nz-tabset>
</div>